const styles = {
  // Public view
  containerSx: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
    cursor: "pointer",
    borderRadius: "6px",
    "& img": {
      transition: "transform 0.45s ease",
    },
    "&:hover img": {
      transform: "scale(1.05)",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: "55%",
      background: "linear-gradient(to top, rgba(0,0,0,0.78) 0%, transparent 100%)",
      pointerEvents: "none",
      zIndex: 1,
    },
  },

  imageSx: {
    aspectRatio: "1/1",
    width: "100%",
    objectFit: "cover",
    backgroundColor: "#1a1a1a",
    display: "block",
  },

  nameContainerSx: {
    position: "absolute",
    left: "10px",
    right: "10px",
    bottom: "10px",
    color: "white",
    zIndex: 2,
  },

  nameSx: {
    fontSize: { xs: "0.72rem", md: "0.82rem" },
    fontWeight: 400,
    color: "rgba(255,255,255,0.6)",
    letterSpacing: "0.03em",
    lineHeight: 1.2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  stageNameSx: {
    fontSize: { xs: "0.9rem", md: "1.05rem" },
    fontWeight: 700,
    fontFamily: "Raleway, sans-serif",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    lineHeight: 1.3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  // Admin view
  adminContainerSx: {
    cursor: "pointer",
    width: { xs: 195, sm: 210, md: 230 },
    transition: "opacity 0.15s",
    "&:hover": { opacity: 0.75 },
  },

  adminImageSx: {
    width: { xs: 195, sm: 210, md: 230 },
    height: { xs: 195, sm: 210, md: 230 },
    objectFit: "cover",
    borderRadius: "8px",
    backgroundColor: "#1a1a1a",
    display: "block",
  },

  adminInfoBoxSx: { mt: 0.8, px: 0.5 },

  adminStageNameSx: {
    color: "rgba(255,255,255,0.85)",
    fontSize: { xs: "0.85rem", md: "0.9rem" },
    fontWeight: 600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  adminNameSx: {
    color: "rgba(255,255,255,0.35)",
    fontSize: { xs: "0.75rem", md: "0.8rem" },
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

export default styles;
